<template>
  <modal ref="modal">
    <modal-body :message="message" />
    <modal-footer>
      <slot />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>
  
  <script>
  import Modal from "@/views/atoms/Modal";
  import ModalBody from "@/views/atoms/ModalBody";
  import ModalFooter from "@/views/atoms/ModalFooter";
  import CancelButton from '@/views/molecules/buttons/CancelButton';
  
  export default {
    name: "EnterpriseIntegrationModal",
    components: {
      Modal,
      ModalBody,
      ModalFooter,
      CancelButton,
    },
    props: {
      message: {
        type: String,
        default: "",
      },
    },
    methods: {
      show() {
        this.$refs.modal.show();
      },
      hide() {
        this.$refs.modal.hide();
      },
    },
  }
  </script>
  